import React from 'react';

const AdminSidebar = () => {
  return <div>Admin Sidebar Content</div>;
};

export default AdminSidebar;